import { render, staticRenderFns } from "./CdnCreate.vue?vue&type=template&id=9c112c5e&scoped=true"
import script from "./CdnCreate.vue?vue&type=script&lang=js"
export * from "./CdnCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c112c5e",
  null
  
)

export default component.exports